import SplitType from 'split-type';
import LocomotiveScroll from 'locomotive-scroll';
import common from './common';
import {mobile} from "../main_barcino";

const scroll = {


    splitTitleLines() {


        document.querySelectorAll('.-split-lines').forEach(element => {
            const splitText = new SplitType(element, {types: 'lines, words'});
        });

        document.querySelectorAll('.-split-lines').forEach(element => {
            element.classList.add('_ready');
        });

        // const words = document.querySelectorAll('.-split-lines .word'); // Tous les mots dans le conteneur
        // words.forEach((word, index) => {
        //     const delay = index * 0.1; // Calcul du délai global : 100ms par mot
        //     word.style.transitionDelay = `${delay}s`; // Applique le délai calculé au mot
        // });


        //$(".lines").addClass("reveal");


        // // setTimeout(function(){
        //             //     $(".line").addClass("reveal-txt");
        //             // },1500);
        //
        //
        //             // // Vérifie si les lignes sont présentes
        //             // if (splitText.lines) {
        //             //     // Parcours chaque ligne pour ajouter une classe à chaque `div` de ligne
        //             //     splitText.lines.forEach(line => {
        //             //         const lineDiv = document.createElement('div');
        //             //         lineDiv.classList.add('line-group');
        //             //
        //             //         // Ajoute chaque mot de la ligne dans un `span` et le place dans `lineDiv`
        //             //         line.forEach(word => lineDiv.appendChild(word));
        //             //
        //             //         // Ajoute `lineDiv` dans l'élément parent
        //             //         element.appendChild(lineDiv);
        //             //     });
        //             // } else {
        //             //     console.warn("Aucune ligne trouvée pour l'élément", element);
        //             // }

        // document.querySelectorAll('.-split-lines').forEach(element => {
        //     // Applique SplitType pour découper par mots
        //     const splitText = new SplitType(element, { types: 'words' });
        //
        //     // Ajoute la classe 'revealTxt' à chaque mot pour des animations
        //     splitText.words.forEach(word => {
        //         word.classList.add('revealTxt');
        //     });
        // });
        // splt({
        //     split: 'words', // Découpe le texte par mots
        //     reveal: true    // Ajoute la classe 'reveal' à chaque mot pour les animations
        // });

        // Select all elements with the class '-split-lines'
        // document.querySelectorAll('.-split-lines').forEach(element => {
        //     // Apply SPLT.js to split the text into lines
        //     splt({
        //         target: element,
        //         reveal: true // Enables the 'reveal' class for animation purposes
        //     });
        // });
    },
    splitElementIntoLines(element) {
        const range = document.createRange();
        const lines = [];
        let currentLineNodes = [];
        let currentLineRect = null;

        Array.from(element.childNodes).forEach(node => {
            if ((node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') || node.nodeType === Node.ELEMENT_NODE) {
                range.selectNodeContents(node);
                const rects = Array.from(range.getClientRects());
                rects.forEach((rect, index) => {
                    if (currentLineNodes.length && currentLineRect && rect.top !== currentLineRect.top) {
                        // Create a wrapper for the current line
                        const wrapper = document.createElement('div');
                        wrapper.classList.add('reveal-txt');
                        currentLineNodes.forEach(n => wrapper.appendChild(n.cloneNode(true)));
                        lines.push(wrapper);
                        currentLineNodes = [];
                    }
                    currentLineNodes.push(node);
                    currentLineRect = rect;
                });
            }
        });

        if (currentLineNodes.length) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('reveal-txt');
            currentLineNodes.forEach(n => wrapper.appendChild(n.cloneNode(true)));
            lines.push(wrapper);
        }

        // Remove duplicate lines
        return lines.filter((line, index, self) =>
                index === self.findIndex((t) => (
                    t.textContent === line.textContent
                ))
        );
    },

    splitTextIntoLines() {
        document.querySelectorAll('.__content').forEach(container => {
            container.querySelectorAll('h2, h3, strong, p').forEach(el => {
                const lines = this.splitElementIntoLines(el);
                const parent = el.parentElement;

                lines.forEach(line => {
                    parent.insertBefore(line, el);
                });

                parent.removeChild(el);
            });
        });
    },
    debounce(func, wait = 100) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    },
    locomotiveScroll: null,
    observRatio: 0.3,
    observers: {
        section: null,
        general: null,
        revealTxt: null,
    },
    count: 0,
    revealElementsInView: [],

    show() {
        //this.splitTitleLines();
        //this.splitTextIntoLines();
        this.locomotive();
        this.observe();
        //this.handleGlobalOpacity();
        //this.initCardObserver();

    },

    observe() {
        this.observers.section = new IntersectionObserver(this.handleSections.bind(this), {
            root: null,
            rootMargin: '0px',
            threshold: this.observRatio
        });
        this.observers.general = new IntersectionObserver(this.handleIntersect.bind(this), {
            root: null,
            rootMargin: '0px',
            threshold: this.observRatio
        });
        this.observers.revealTxt = new IntersectionObserver(this.handleRevealTxt.bind(this), {
            root: null,
            rootMargin: '0px',
            threshold: [0.1, 0.3, 0.6, 0.9]
        });

        this.observers.global = new IntersectionObserver(this.handleGlobalOpacity.bind((this)), {
            root: null, // Utilise le viewport comme référence
            rootMargin: '0px',
            threshold: [0, 0.1, 0.2, 0.5, 0.7, 1] // Seuils pour les déclencheurs de la fonction
        });

        // this.observers.card = new IntersectionObserver(this.handleCardVisibility.bind(this), { // Ajout de l'observer pour les cards
        //     root: null,
        //     rootMargin: '0px',
        //     threshold: [0, 0.2, 0.3, 0.8, 1]
        // });

        document.querySelectorAll('.reveal,.reveal_img,.reveal_op,._reveal_title,.line').forEach(el => this.observers.general.observe(el));
        document.querySelectorAll('._section,._section_refresh').forEach(el => this.observers.section.observe(el));
        document.querySelectorAll('.reveal-txt').forEach(el => this.observers.revealTxt.observe(el));
        document.querySelectorAll('.reveal-opacity').forEach(el => this.observers.global.observe(el));
        //document.querySelectorAll('.view-opacity').forEach(el => this.observers.card.observe(el)); // Observer les cards

        // // Sélectionner tous les éléments avec la classe `reveal-opacity`
        // const elementsToObserve = document.querySelectorAll('.reveal-opacity');
        // // Ajouter chaque élément au `IntersectionObserver`
        // elementsToObserve.forEach(element => observer.observe(element));

    },

    initCardObserver() {
        const cards = document.querySelectorAll('.view-opacity');

        const cardObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio >= 0.3 && entry.intersectionRatio < 0.9) {
                    entry.target.classList.add('view-opacity-visible');
                } else if (entry.intersectionRatio >= 0.9) {
                    entry.target.classList.add('view-opacity-exit');
                    entry.target.classList.remove('view-opacity-visible');
                } else {
                    entry.target.classList.remove('view-opacity-visible');
                    entry.target.classList.remove('view-opacity-exit');
                }
            });
        }, {
            root: null,
            threshold: [0, 0.3, 0.9, 1]
        });

        cards.forEach(card => cardObserver.observe(card));
    },

    handleCardVisibility(entries) {
        entries.forEach(entry => {
            //console.log(entry.intersectionRatio);
            if (entry.isIntersecting) {

                const viewportHeight = common.$windowH; // Taille de l'écran (hauteur du viewport)
                const elementHeight = entry.boundingClientRect.height; // Taille de l'élément observé
                const topDistance = entry.boundingClientRect.top; // Distance entre le haut de l'élément et le haut du viewport


                //console.log(scroll.Y );

                if (scroll.direction === "down") {

                    //console.log(topDistance);

                    // && entry.intersectionRatio < 1
                    if (entry.intersectionRatio >= 0.3 && entry.intersectionRatio <= 1) {
                        entry.target.classList.add('view-opacity-visible');
                        entry.target.classList.remove('view-opacity-exit');
                    } else {
                        entry.target.classList.add('view-opacity-exit');
                        entry.target.classList.remove('view-opacity-visible');
                    }

                    // else if (entry.boundingClientRect.top <= 150) {
                    //     console.log('entry exit');
                    //     // L'élément atteint le haut du viewport
                    //     //this.observers.card.unobserve(entry.target); // Arrêter d'observer la carte
                    //     entry.target.classList.add('view-opacity-exit');
                    //     entry.target.classList.remove('view-opacity-visible');
                    // }

                } else if (scroll.direction === "up") {
                    entry.target.classList.remove('view-opacity-exit');
                    entry.target.classList.add('view-opacity-visible');
                }

                // else {
                //     entry.target.classList.remove('view-opacity-visible');
                // }

                // else if (entry.intersectionRatio >= 0.8) {
                //     this.observers.card.unobserve(entry.target); // Arrêter d'observer la carte avant de lui appliquer la classe 'view-opacity-exit'
                //     entry.target.classList.add('view-opacity-exit');
                //     //entry.target.classList.remove('view-opacity-visible');
                // }
            } else {
                entry.target.classList.remove('view-opacity-visible');
                entry.target.classList.remove('view-opacity-exit');
            }
        });
    },

    handleSections(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio > this.observRatio) {
                this.count = 0;
                //console.log("Section in view");
            }
        });
    },

    handleIntersect(entries) {
        entries.forEach(entry => {
            if (entry.intersectionRatio > this.observRatio) {
                this.count++;
                if (entry.target.classList.contains('reveal')) {
                    entry.target.classList.remove('reveal_less');
                    entry.target.classList.add('reveal-visible');
                } else if (entry.target.classList.contains('line')) {
                    entry.target.classList.add('reveal_line');
                } else if (entry.target.classList.contains('reveal_op')) {
                    entry.target.classList.add('reveal_op-visible');
                } else if (entry.target.classList.contains('_reveal_title')) {
                    entry.target.classList.add('reveal_title_visible');
                } else {
                    entry.target.classList.add('reveal-img-visible');
                }
                entry.target.classList.add(`reveal-delay-${entry.target.dataset.delay || this.count}`);
            }
        });
    },


    handleRevealTxt(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Ajouter l'élément au tableau si visible
                if (!this.revealElementsInView.includes(entry.target)) {
                    this.revealElementsInView.push(entry.target);
                }
            } else {
                // Retirer l'élément du tableau s'il n'est plus visible
                this.revealElementsInView = this.revealElementsInView.filter(el => el !== entry.target);
            }
            //console.log(this.revealElementsInView);
        });


    },
    handleGlobalOpacity() {
        // if (this.locomotiveScroll) {
        //     this.locomotiveScroll.on('scroll', (args) => {
        //         const elements = document.querySelectorAll('.reveal-opacity');
        //         elements.forEach(el => {
        //             const rect = el.getBoundingClientRect();
        //             const viewportHeight = window.innerHeight;
        //             const elementMidpoint = rect.top + (rect.height / 2);
        //             const viewportMidpoint = viewportHeight / 2;
        //
        //             let opacity = Math.min(1, Math.max(0, 1 - Math.abs(viewportMidpoint - elementMidpoint) / viewportMidpoint));
        //             el.style.opacity = opacity;
        //             el.style.transition = 'opacity 0.6s ease';
        //         });
        //     });
        // }
    },

    handleRevealTxt(entries) {
        entries.forEach(entry => {


            // const viewportHeight = window.innerHeight;
            // const elementRect = entry.boundingClientRect;
            // const elementTop = elementRect.top;
            // const elementHeight = elementRect.height;
            //
            // // Calculer le ratio d'intersection en fonction de la position de scroll
            // let scrollPosition = scroll.Y || 0;
            // let scrollRatio = Math.min(Math.max((viewportHeight - elementTop + scrollPosition) / viewportHeight, 0), 1);
            //
            // console.log(scroll.Y + " -- " + scrollRatio);
            //
            // // Appliquer l'opacité progressivement de 0 à 1
            // entry.target.style.transition = 'opacity 0.6s ease';
            // entry.target.style.opacity = scrollRatio;

            //if (entry.intersectionRatio > this.observRatio) {
            //     console.log(entry.target + " - " + entry.intersectionRatio);
            //     const viewportHeight = window.innerHeight;
            //     const elementRect = entry.boundingClientRect;
            //     const elementTop = elementRect.top;
            //     const elementHeight = elementRect.height;
            //     let opacity = Math.min(Math.max((viewportHeight - elementTop) / viewportHeight, 0), 1);
            //
            //     //console.log(scroll.locomotiveScroll.scroll.instance);
            //     // Ajuster l'opacité en fonction de la direction du scroll
            //     if (scroll.locomotiveScroll && scroll.locomotiveScroll.scroll.instance.direction === 'down') {
            //         console.log("down");
            //         entry.target.style.opacity = opacity;
            //     } else if (scroll.locomotiveScroll && scroll.locomotiveScroll.scroll.instance.direction === 'up') {
            //         // && elementRect.bottom > viewportHeight * 0.7
            //         console.log("up");
            //         entry.target.style.opacity = opacity;
            //     } else {
            //         //entry.target.style.opacity = 0;
            //     }
            //
            //     entry.target.style.transition = 'opacity 0.6s ease';
            //}

            // }else{
            //     entry.target.style.opacity = 0;
            // }
        });
    },


    locomotive() {

        setTimeout(() => {

            this.locomotiveScroll = new LocomotiveScroll({
                lenisOptions: {
                    //wrapper: window,
                    //content: document.documentElement,
                    //content: document.querySelector('.barba-container'),
                    lerp: 0.1,
                    duration: 1.2,
                    orientation: 'vertical',
                    gestureOrientation: 'vertical',
                    smoothWheel: true,
                    smoothTouch: false,
                    // Laisse le scroll natif aux panneaux ; le CSS verrouille la page.
                    prevent: () => document.body.classList.contains('mobile-nav-open')
                        || Boolean(document.querySelector('.search-drawer.is-open, .recipe-drawer.is-open, .bc-filter-drawer.is-open, .bc-founder-drawer.is-open, .bc-region-drawer.is-open')),
                    wheelMultiplier: 1,
                    touchMultiplier: 2,
                    normalizeWheel: true,
                    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
                },
            });

            // const elements = document.querySelectorAll('.reveal-opacity');
            // elements.forEach(el => {
            //     this.locomotiveScroll.addScrollElements({
            //         el,
            //         offset: '0%',
            //         callback: (progress) => {
            //             const viewportHeight = window.innerHeight;
            //             const elementTop = el.getBoundingClientRect().top;
            //             const elementMidpoint = elementTop + el.getBoundingClientRect().height / 2;
            //             const viewportMidpoint = viewportHeight / 2;
            //
            //             let opacity = Math.min(1, Math.max(0, 1 - Math.abs(viewportMidpoint - elementMidpoint) / viewportMidpoint));
            //             el.style.opacity = opacity;
            //             el.style.transition = 'opacity 0.6s ease';
            //         }
            //     });
            // });


            //console.log(this.locomotiveScroll);

            let _lastScrollY = 0;
            const _siteHeader = document.querySelector('.site-header');
            // Doit rester égal au seuil de .is-scrolled (barcino_header.js) : un
            // seuil plus haut ici laissait une zone de scroll où le header passait
            // en fond blanc (.is-scrolled) avant d'atteindre celui-ci et de se
            // masquer — on voyait la pill blanche apparaître puis disparaître au
            // lieu de disparaître directement.
            const _NAV_THRESHOLD = 200; // px avant de commencer à masquer

            window.addEventListener('scroll', function () {
                scroll.Y = window.scrollY;

                if (mobile.state === false) {
                    if (scroll.Y > 300) {
                        $("header").addClass("_move");
                    } else {
                        $("header").removeClass("_move");
                    }
                }

                if (_siteHeader && mobile.state === false) {
                    if (scroll.Y > _lastScrollY && scroll.Y > _NAV_THRESHOLD) {
                        // Scroll vers le bas → masquer
                        _siteHeader.classList.add('is-nav-hidden');
                    } else if (scroll.Y < _lastScrollY) {
                        // Scroll vers le haut → réafficher
                        _siteHeader.classList.remove('is-nav-hidden');
                    }
                }

                _lastScrollY = scroll.Y;
            });

            // this.revealElementsInView.forEach(el => {
            //     const elementRect = el.getBoundingClientRect();
            //     const viewportHeight = window.innerHeight;
            //     const elementCenter = elementRect.top + (elementRect.height / 2);
            //
            //     // Calculer l'opacité en fonction de la position de l'élément
            //     let opacity;
            //     if (elementCenter >= viewportHeight * 0.3 && elementCenter <= viewportHeight * 0.95) {
            //         opacity = 1;
            //     } else if (elementCenter < viewportHeight * 0.3) {
            //         opacity = Math.max(elementCenter / (viewportHeight * 0.3), 0);
            //     } else if (elementCenter > viewportHeight * 0.95) {
            //         opacity = Math.max(1 - ((elementCenter - viewportHeight * 0.95) / (viewportHeight * 0.1)), 0);
            //     } else {
            //         opacity = 0;
            //     }
            //
            //     // Appliquer l'opacité
            //     el.style.opacity = opacity;
            // });


            // this.locomotiveScroll = new LocomotiveScroll({
            //     el: document.querySelector('.barba-container'),
            //     smooth: true,
            //     gestureDirection: "vertical",
            //     lerp: 0.07, // Réduire légèrement le lerp pour réduire les tremblements
            //     multiplier: 0.8, // Augmenter le multiplier pour un scroll plus fluide
            //     touchMultiplier: 1.1, // Réduire la sensibilité du scroll sur mobile
            //     smoothMobile: true, // Activer le smooth sur mobile pour éviter les tremblements
            //     getDirection: true,
            //     smartphone: {
            //         smooth: true
            //     },
            //     tablet: {
            //         smooth: true
            //     }
            // });

            //this.locomotiveScroll.scrollTo(0, {duration: 0, disableLerp: true});

            // this.locomotiveScroll.on("scroll", (args) => {
            //
            // });

            // this.locomotiveScroll.on("scroll", (e) => {
            //     // scroll.Y = e.scroll.y;
            //     // scroll.direction = e.direction;
            //
            //     console.log(e);
            //
            //
            //     // this.revealElementsInView.forEach(el => {
            //     //     const elementRect = el.getBoundingClientRect();
            //     //     const viewportHeight = window.innerHeight;
            //     //     const elementCenter = elementRect.top + (elementRect.height / 2);
            //     //
            //     //     // Calculer l'opacité en fonction de la position de l'élément
            //     //     let opacity;
            //     //     if (elementCenter >= viewportHeight * 0.3 && elementCenter <= viewportHeight * 0.95) {
            //     //         opacity = 1;
            //     //     } else if (elementCenter < viewportHeight * 0.3) {
            //     //         opacity = Math.max(elementCenter / (viewportHeight * 0.3), 0);
            //     //     } else if (elementCenter > viewportHeight * 0.95) {
            //     //         opacity = Math.max(1 - ((elementCenter - viewportHeight * 0.95) / (viewportHeight * 0.1)), 0);
            //     //     } else {
            //     //         opacity = 0;
            //     //     }
            //     //
            //     //     // Appliquer l'opacité
            //     //     el.style.opacity = opacity;
            //     // });
            //
            //
            //     // document.querySelectorAll('.reveal-txt').forEach(el => {
            //     //     const elementRect = el.getBoundingClientRect();
            //     //     const viewportHeight = window.innerHeight;
            //     //     const elementTop = elementRect.top;
            //     //     const elementBottom = elementRect.bottom;
            //     //
            //     //     // Calculer l'opacité en fonction de la position de l'élément
            //     //     let visibilityRatio = (viewportHeight - elementTop) / viewportHeight;
            //     //     let opacity;
            //     //
            //     //     if (visibilityRatio >= 0.3 && visibilityRatio <= 0.9) {
            //     //         opacity = 1;
            //     //     } else if (visibilityRatio < 0.3) {
            //     //         opacity = visibilityRatio / 0.3;
            //     //     } else if (visibilityRatio > 0.9) {
            //     //         opacity = Math.max(1 - ((visibilityRatio - 0.9) / 0.1), 0);
            //     //     } else {
            //     //         opacity = 0;
            //     //     }
            //     //
            //     //     // Appliquer l'opacité
            //     //     el.style.opacity = opacity;
            //     // });
            //
            //
            //     //
            //     // //console.log(scroll.Y);
            //     // const header = document.querySelector("header");
            //     // if (e.scroll.y > 100) {
            //     //     header.classList.add("_mov_header");
            //     // } else {
            //     //     header.classList.remove("_mov_header", "_force_header");
            //     // }
            //     //
            //     // if (e.direction === "down") {
            //     //     header.classList.remove("_force_header");
            //     // }
            // });
            //
            // // Désactiver l'update automatique sur l'événement 'call' pour éviter les tremblements
            // this.locomotiveScroll.on("call", (func) => {
            //     if (func === 'sticky') {
            //         // Supprimer la mise à jour fréquente qui causait les tremblements
            //         console.log("Sticky element in view");
            //     }
            // });


        }, 300);


    },

    // interpolateColor(color1, color2, factor) {
    //     const hexToRgb = hex => {
    //         const bigint = parseInt(hex.replace("#", ""), 16);
    //         const r = (bigint >> 16) & 255;
    //         const g = (bigint >> 8) & 255;
    //         const b = bigint & 255;
    //         return [r, g, b];
    //     };
    //
    //     const rgb1 = hexToRgb(color1);
    //     const rgb2 = hexToRgb(color2);
    //     const result = rgb1.map((value, index) => Math.round(value + factor * (rgb2[index] - value)));
    //     return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
    // },

    destroy() {
        if (this.locomotiveScroll) {
            this.locomotiveScroll.destroy();
            this.locomotiveScroll = null;
        }
    },
    stop() {
        if (this.locomotiveScroll) {
            this.locomotiveScroll.stop();
            //this.locomotiveScroll = null;
        }
    },
    update() {
        if (this.locomotiveScroll) {
            requestAnimationFrame(() => this.locomotiveScroll.update());
        }
    }
};

export default scroll;
